module.exports = __webpack_public_path__ + "img/blueBgImg.8e9133c0.png";